import React from 'react'
import {
    Container, Card, CardBody, CardTitle
} from 'reactstrap'
import { withNamespaces } from "react-i18next"
import Breadcrumbs from '../../components/Common/Breadcrumb'

const Index = (props ) => {
    const _shareOnWhatsApp = () => {
        window.analytics.track(`Request return via Whatsapp`)
        window.open(`https://api.whatsapp.com/send?phone=525540747210&text=Quisiera%20solicitar%20una%20devolución`)
    }

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <Breadcrumbs
                        title={props.t("Devoluciones")}
                        breadcrumbItem={props.t("Devoluciones")}
                        parentLink={`/devoluciones`}
                    />

                    <Card>
                        <CardBody>
                            <CardTitle>¿Necesitas realizar una devolución?</CardTitle>

                            <button onClick={ _shareOnWhatsApp } 
                                target={`_blank`}
                                className="btn btn-whatsapp btn-rounded waves-effect waves-light mb-2 mr-2">
                                <i className="bx bxl-whatsapp"></i>
                                Enviar Mensaje
                            </button>
                        </CardBody>
                    </Card>
                </Container>
            </div>
        </React.Fragment>
    )
}

export default withNamespaces()(Index)
